import "./containers.css"

export function Box1({title, extra_classes = "", children}) {
    return (
        <div className={`box v1 ${extra_classes}`}>
            <h1 className="heading v1"> {title} </h1> 
            <div className="box_internal">
                {children}
                <p className="fallback"> No Content </p>
            </div>
        </div>
    )
}

export function Box2({title, extra_classes = "", children}) {
    return (
        <div className={`box v2 ${extra_classes}`}>
            <h1 className="heading v2"> {title} </h1> 
            <div className="box_internal">
                {children}
                <p className="fallback"> No Content </p>
            </div>
        </div>
    )
}

export function Box3({title, extra_classes = "", children}) {
    return (
        <div className={`box v3 ${extra_classes}`}>
            <h1 className="heading v3"> {title} </h1> 
            <div className="box_internal">
                {children}
                <p className="fallback"> No Content </p>
            </div>
        </div>
    )
}